import type { EventMapType } from '../types';

/**
 * Maps a Hike Event's map reference to the trail/custom route id properties expected by the
 * Hike Event analytics events. Trails ('T') log a `trail_id`, custom routes ('M') a `custom_route_id`.
 */
const getEventMapAnalyticsIds = (mapType: EventMapType, mapId: number): { custom_route_id?: number; trail_id?: number } =>
  mapType === 'T' ? { trail_id: mapId } : { custom_route_id: mapId };

export default getEventMapAnalyticsIds;
